module.exports = __webpack_public_path__ + "static/img/h3_x2.abb609b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h3_x2.png
// module id = Nshp
// module chunks = 1